import { getGlobalErrorHandler } from './global-state';
import { NormalizedEventAttributes } from './types';

type Consume = (title: string, attributes: NormalizedEventAttributes) => void;

const eventListeners = new Map<string, Consume>();

export const removeListener = (id: string) => {
  eventListeners.delete(id);
};

export const addListener = (id: string, consume: Consume) => {
  eventListeners.set(id, consume);
  return () => removeListener(id);
};

export const notifyEvent: Consume = (title, attributes) => {
  eventListeners.forEach((listener) => {
    try {
      listener(title, attributes);
    } catch (e) {
      console.error(e);
      getGlobalErrorHandler()?.(e);
    }
  });
};
